import React, { Fragment } from "react";

export default (
  <>
    <path d="M19 16C19 17.1046 18.1046 18 17 18C15.8954 18 15 17.1046 15 16C15 14.8954 15.8954 14 17 14C18.1046 14 19 14.8954 19 16Z" />
    <path d="M10 16C10 17.6569 8.65685 19 7 19C5.34315 19 4 17.6569 4 16C4 14.3431 5.34315 13 7 13C8.65685 13 10 14.3431 10 16Z" />
    <path d="M17 8.5C17 10.433 15.433 12 13.5 12C11.567 12 10 10.433 10 8.5C10 6.567 11.567 5 13.5 5C15.433 5 17 6.567 17 8.5Z" />
  </>
);
